import React, { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { X } from "lucide-react";
import { ImageField } from "./content/fields";

const EMPTY = { title: "", date: "", venue: "", city: "", lineup: "", poster_url: "", description: "", price_from: 20, entry_price: 25, list_url: "" };

const toLocalInput = (iso) => {
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

const fromEvent = (ev) => ev ? {
  title: ev.title, date: toLocalInput(ev.date), venue: ev.venue, city: ev.city, lineup: (ev.lineup || []).join(", "),
  poster_url: ev.poster_url, description: ev.description || "", price_from: ev.price_from ?? 0, entry_price: ev.entry_price ?? 0, list_url: ev.list_url || "",
} : EMPTY;

function Field({ label, k, form, setForm, ...rest }) {
  return (
    <div>
      <div className="label-mono mb-1">{label}</div>
      <input value={form[k]} onChange={e=>setForm({...form,[k]:e.target.value})} className="input-dark" data-testid={`new-event-${k}`} {...rest}/>
    </div>
  );
}

export default function NewEventModal({ event, onClose, onCreated }) {
  const [form, setForm] = useState(() => fromEvent(event));
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!form.poster_url) { toast.error("Aggiungi la locandina"); return; }
    setLoading(true);
    const body = {
      ...form, lineup: form.lineup.split(",").map(s=>s.trim()).filter(Boolean),
      price_from: Number(form.price_from), entry_price: Number(form.entry_price),
      date: event && form.date === toLocalInput(event.date) ? event.date : new Date(form.date).toISOString()
    };
    try {
      if (event) { await api.put(`/events/${event.id}`, body); toast.success("Evento aggiornato"); }
      else { await api.post("/events", body); toast.success("Evento creato"); }
      onCreated();
    } catch (err) { toast.error(err.response?.data?.detail || "Errore"); }
    finally { setLoading(false); }
  };
  const f = { form, setForm };
  return (
    <div className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-md flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-neutral-950 border border-neutral-800 w-full max-w-lg p-8 relative max-h-[90vh] overflow-y-auto" onClick={e=>e.stopPropagation()} data-testid="new-event-modal">
        <button className="absolute top-4 right-4 text-neutral-500 hover:text-white" onClick={onClose} data-testid="new-event-close" aria-label="Chiudi"><X/></button>
        <div className="label-mono text-neon mb-2">{event ? "MODIFICA EVENTO" : "NUOVO EVENTO"}</div>
        <form onSubmit={submit} className="space-y-5 mt-6">
          <Field label="TITOLO" k="title" required {...f}/>
          <Field label="DATA" k="date" type="datetime-local" required {...f}/>
          <div className="grid grid-cols-2 gap-4">
            <Field label="PREZZO DA €" k="price_from" type="number" required {...f}/>
            <Field label="INGRESSO TAVOLI €" k="entry_price" type="number" min="0" step="0.01" required {...f}/>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Field label="LOCALE" k="venue" required {...f}/>
            <Field label="CITTÀ" k="city" required {...f}/>
          </div>
          <Field label="LINEUP (separati da virgola)" k="lineup" {...f}/>
          <ImageField field={{ key: "event-poster", label: "LOCANDINA" }} value={form.poster_url} onChange={v=>setForm(s=>({...s, poster_url: v}))}/>
          <Field label="LINK LISTA (opz.)" k="list_url" placeholder="https://..." {...f}/>
          <Field label="DESCRIZIONE" k="description" {...f}/>
          <button disabled={loading} className="btn-primary w-full" data-testid="new-event-submit">{loading?"...": event ? "SALVA MODIFICHE" : "CREA EVENTO"}</button>
        </form>
      </div>
    </div>
  );
}
